import { takeLatest, put, call } from 'redux-saga/effects';

import { listProcedimentoCadastro } from '../service';
import {
  TABLE_PROCEDIMENTO_CADASTRO,
  TABLE_PROCEDIMENTO_CADASTRO_PENDING,
  TABLE_PROCEDIMENTO_CADASTRO_SUCCESS,
  TABLE_PROCEDIMENTO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListProcedimentoCadastro(action) {
  yield put({ type: TABLE_PROCEDIMENTO_CADASTRO_PENDING })

  try {
    const table = yield call(listProcedimentoCadastro, action.args)
    yield put({ type: TABLE_PROCEDIMENTO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_PROCEDIMENTO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListProcedimentoCadastro() {
  yield takeLatest(TABLE_PROCEDIMENTO_CADASTRO, sagaListProcedimentoCadastro)
}